<script>
    import Header from "../components/Headers/Header.svelte";

    import EmailForm from "./SignUpFlow/EmailForm.svelte";

    let emoji = "mailbox.svg";
</script>

<style>
    .emoji {
        width: 175px;
    }

    div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        margin-top: var(--spacer-large);
    }
</style>

<Header
    title="Hey there!"
    subtitle="Hope you’re having lovely day"
    emojiUrl="/emojis/waving-hand.svg" />

<div class="signup-container">
    <object
        title="mailbox animation"
        data={'emojis/' + emoji}
        type="image/svg+xml"
        id="mailbox-svg"
        class="emoji" />

    <EmailForm />
</div>
